const readFirstValidationMessage = (errors) => {
  const firstFieldMessages = Object.values(errors || {})[0];

  return Array.isArray(firstFieldMessages) ? firstFieldMessages[0] : firstFieldMessages;
};

export const readApiErrorMessage = (error, fallbackMessage) => {
  const responseData = (error && error.response && error.response.data) || {};

  return responseData.error || readFirstValidationMessage(responseData.errors) || responseData.message || fallbackMessage;
};
